module.exports = __webpack_public_path__ + "static/media/points10_3.4c7daad2.png";